<template>
  <div class="video-diagnosis-statistics container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        node-key="key"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--表格数据-->
    <div class="col-2">
      <el-form ref="queryForm" class="pagination-table-query-form" :inline="true" @keyup.enter.native="handleFormQuery()">
        <el-form-item label="统计日期">
          <uni-date-picker
            v-model="date">
          </uni-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleFormQuery()" type="primary">查 询</el-button>
          <el-button @click="resetQueryForm()">重 置</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col class="chart-container" :span="12">
          <div class="chart-title">各状态数量占比</div>
          <annular-pie
            ref="annularPie"
            :id="pieId"
            :source="pieData"
            :color="pieColor"
            :title="pieTitle"
            :legend="pieLegend"
            style="width:100%; height:300px"
          ></annular-pie>
        </el-col>
        <el-col class="chart-container" :span="12">
          <div class="chart-title">各区域数量对比</div>
          <bar
              ref="bar"
              :id="barId"
              :source="barData"
              :color="barColor"
              style="width:100%; height:300px"
          ></bar>
        </el-col>
      </el-row>
      <div class="pagination-table-container">
        <el-table :data="tableData"
                  ref="table"
                  v-loading="loading"
                  border element-loading-background="rgba(255, 255, 255, 0.8)"
                  element-loading-spinner="el-icon-loading"
                  element-loading-text="努力加载中..."
                  style="width: 100%">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="区域" prop="regionName" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="接入数" prop="totalCount" width="80"></el-table-column>
            <el-table-column label="正常数" prop="normalCount" width="80"></el-table-column>
            <el-table-column label="报警数" prop="alarmCount" width="80"></el-table-column>
            <el-table-column label="偏暗" prop="brightLowCount" width="80"></el-table-column>
            <el-table-column label="偏亮" prop="brightHighCount" width="80"></el-table-column>
            <el-table-column label="偏色" prop="colorCastCount" width="80"></el-table-column>
            <el-table-column label="噪声" prop="noiseCount" width="80"></el-table-column>
            <el-table-column label="条纹" prop="striageCount" width="80"></el-table-column>
            <el-table-column label="图像模糊" prop="contrastLowCount" width="80"></el-table-column>
            <el-table-column label="画面冻结" prop="freezeCount" width="80"></el-table-column>
            <el-table-column label="视频丢失" prop="lostCount" width="80"></el-table-column>
            <el-table-column label="画面抖动" prop="shakeCount" width="80"></el-table-column>
            <el-table-column label="统计日期" prop="statDateTime" width="120">
              <template slot-scope="scope"> {{strDateFromSTime_t(scope.row.statDateTime)}}</template>
            </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentPageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="tableQueryParams.pageNum"
          :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
          :page-size.sync="tableQueryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableTotalRow">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import VideoDiagnosisStatistics from './VideoDiagnosisStatistics.js'
export default VideoDiagnosisStatistics
</script>

<style lang="scss">
  // @import "VideoDiagnosisStatistics";
</style>



// WEBPACK FOOTER //
// src/views/statistics/videoDiagnosisStatistics/VideoDiagnosisStatistics.vue